import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useHardFactsTitle } from "@/contexts/classified";
import { PriceInformations, PriceValue } from "@/components/Sections/Hardfacts";
export const HardfactInfo = () => {
    const { title, titleAdditions } = useHardFactsTitle();
    const formattedTitle = [title, ...titleAdditions].join(" · ");
    return (_jsxs(Box, { display: "flex", flexDirection: "column", gap: "spacing.8", children: [_jsx(Box, { as: "span", typography: "typography.body.16.bold", children: formattedTitle }), _jsxs(Box, { display: "flex", alignItems: "baseline", gap: "spacing.4", flexWrap: "wrap", children: [_jsx(PriceValue, {}), _jsx(PriceInformations, {})] })] }));
};
